import { createSelector } from '@reduxjs/toolkit'
import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'
import { ILicenseEvent } from '../types/LicenseEvent'

export const selectPaginatedItems = createSelector(
	[
		(store: StoreSchema) => store.licenseEvents.paginatedLicenseEvents.items,
		(store: StoreSchema) => store.licenseEvents.paginatedLicenseEvents.currentPage,
		(store: StoreSchema) => store.licenseEvents.limit,
		(store: StoreSchema) => store.licenseEvents.sort.sort,
		(store: StoreSchema) => store.licenseEvents.sort.direction
	],
	(items, currentPage, limit, sort, direction) => {
		let sorted = [...items] as ILicenseEvent[]

		if (sort && direction) {
			sorted.sort((a, b) => {
				const aVal = a[sort as keyof ILicenseEvent] as string
				const bVal = b[sort as keyof ILicenseEvent] as string

				if (aVal < bVal) return direction === 'ascending' ? -1 : 1
				if (aVal > bVal) return direction === 'ascending' ? 1 : -1
				return 0
			})
		}

		const start = (currentPage - 1) * limit
		const end = start + limit

		return sorted.slice(start, end)
	}
)